export function gramsToKilograms(grams: number): number {
  return grams / 1000;
}
